<script setup lang="ts">
import '@google/model-viewer';

const props = defineProps({
  src: { type: String, required: true },
  poster: { type: String, required: true },
});

const { src, poster } = toRefs(props);
</script>

<template>
  <model-viewer
    class="aspect-1 h-full w-full"
    :src="src"
    :poster="poster"
    shadow-intensity="1"
    touch-action="pan-y"
    camera-controls
  ></model-viewer>
</template>
